// extracted by mini-css-extract-plugin
module.exports = {"OrdersListHeading":"styles_OrdersListHeading__3TTLV","OrdersListTable":"styles_OrdersListTable__EkKAV","OrdersListTableHeader":"styles_OrdersListTableHeader__35rlv"};